import { render, staticRenderFns } from "./CaregivingResource.vue?vue&type=template&id=3b6fcfa6"
import script from "./CaregivingResource.vue?vue&type=script&lang=js"
export * from "./CaregivingResource.vue?vue&type=script&lang=js"
import style0 from "./CaregivingResource.vue?vue&type=style&index=0&id=3b6fcfa6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports